function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1539.16 -418.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1588.59,418.5l-14.123,8.827v-2.118a5.3,5.3,0,0,0-5.3-5.3h-24.715a5.3,5.3,0,0,0-5.3,5.3v21.183a5.3,5.3,0,0,0,5.3,5.3h24.715a5.3,5.3,0,0,0,5.3-5.3v-2.118l14.123,8.827Zm-17.654,27.892a1.765,1.765,0,0,1-1.764,1.766h-24.715a1.765,1.765,0,0,1-1.765-1.766V425.209a1.765,1.765,0,0,1,1.765-1.766h24.715a1.765,1.765,0,0,1,1.764,1.766Zm14.123.354-10.592-6.62v-8.65l10.592-6.621Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.347,
  height: 3.173,
  transform: "translate(1548.136 428.857)"
}));

var SvgVideoGallery = function SvgVideoGallery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.43,
    height: 34.601,
    viewBox: "0 0 49.43 34.601",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoGallery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video_gallery.9186adf3.svg";
export { ForwardRef as ReactComponent };